import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const PreliminaryProtocols = () => {
    const [protocols, setProtocols] = useState([]);
    console.log(protocols, "prot344ocols");
    const [loading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [error, setError] = useState(null);
    const [authToken, setAuthToken] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedProtocol, setSelectedProtocol] = useState(null);
    const [newName, setNewName] = useState("");
    const [newDescription, setNewDescription] = useState("");
    const [cloning, setCloning] = useState(false);

    useEffect(() => {
        loginAndFetchProtocols();
    }, []);

    const loginAndFetchProtocols = async () => {
        try {
            // First, get the auth token
            const token = await fetchAuthToken();
            if (token) {
                setAuthToken(token);
                // Then fetch protocols with the token
                await fetchProtocols(token);
            }
        } catch (err) {
            console.error('Error in login and fetch:', err);
            setError(err.message);
            setLoading(false);
        }
    };

    const fetchAuthToken = async () => {
        try {
            const response = await fetch('https://s2.genetica.ai:3001/Cortex/Users/$login', {
                method: 'POST',
                headers: {
                    'accept': 'application/json, text/plain, */*',
                    'accept-language': 'en-US,en;q=0.9',
                    'authorization': 'Basic ZjJhOmYyYTExMQ==',
                    'content-type': 'application/json',
                    'origin': 'https://s2.genetica.ai:3001',
                    'priority': 'u=1, i',
                    'referer': 'https://s2.genetica.ai:3001/apps/cortex/',
                    'sec-ch-ua': '"Google Chrome";v="143", "Chromium";v="143", "Not A(Brand";v="24"',
                    'sec-ch-ua-mobile': '?0',
                    'sec-ch-ua-platform': '"Windows"',
                    'sec-fetch-dest': 'empty',
                    'sec-fetch-mode': 'cors',
                    'sec-fetch-site': 'same-origin',
                    'user-agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36'
                },
                body: JSON.stringify(["cortex"])
            });

            if (!response.ok) {
                throw new Error(`Login failed! status: ${response.status}`);
            }

            const data = await response.json();
            console.log("Login response:", data);

            // Extract token from response (adjust based on actual response structure)
            const token = data.token || data.accessToken || data;
            return token;
        } catch (err) {
            console.error('Error fetching auth token:', err);
            throw err;
        }
    };

    const getNextProtocolName = (protocolName) => {
        // Extract base name and current number if exists
        const match = protocolName.match(/^(.+?)\s*\+(\d+)$/);
        let baseName = match ? match[1].trim() : protocolName;

        // Find all protocols with the same base name
        const similarProtocols = protocols.filter(p => {
            const pMatch = p.name.match(/^(.+?)\s*\+(\d+)$/);
            const pBaseName = pMatch ? pMatch[1].trim() : p.name;
            return pBaseName === baseName;
        });

        // Find the highest number
        let maxNumber = 0;
        similarProtocols.forEach(p => {
            const numMatch = p.name.match(/\+(\d+)$/);
            if (numMatch) {
                maxNumber = Math.max(maxNumber, parseInt(numMatch[1]));
            }
        });

        // Return base name with incremented number
        return `${baseName} ${maxNumber + 1}`;
    };

    const handleCloneClick = (e, protocol) => {
        e.stopPropagation();
        setSelectedProtocol(protocol);
        setNewName(protocol.name);
        setNewDescription(protocol.description || "");
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
        setSelectedProtocol(null);
        setNewName("");
        setNewDescription("");
        setCloning(false);
    };

    const cloneProtocol = () => {
        if (!authToken) {
            toast.error('Authentication token not available. Please refresh the page.', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        if (!newName.trim()) {
            toast.error('Please enter a name for the protocol.', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        // Check for duplicate protocol names
        const duplicateProtocol = protocols.find(p => p.name.toLowerCase() === newName.trim().toLowerCase());
        console.log(duplicateProtocol, "duplicateProtocol");
        if (duplicateProtocol) {
            toast.error('A protocol with this name already exists in your library. Please rename the protocol to continue importing.', {
                position: "top-right",
                autoClose: 5000,
            });
            return;
        }

        setCloning(true);

        fetch('https://s2.genetica.ai:3001/cortex/graphiti/$clone', {
            method: 'POST',
            headers: {
                'authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify([
                selectedProtocol._id,
                newName,
                newDescription
            ])
        })
        .then(response => {
            console.log('Clone API Response Status:', response.status);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            response.json().then(data => {
                console.log('Clone API Response Data:', data);

                // Show success toast
                toast.success(`"${newName}" has been added to your library and is ready for processing.`, {
                    position: "top-right",
                    autoClose: 3000,
                });
                
                // Refresh the protocols list after successful cloning
                fetchProtocols(authToken, true);
                handleModalClose();
                setCloning(false);
            });
        })
        .catch(err => {
            console.error('Error cloning protocol:', err);
            // Show error toast
            toast.error(`Failed to import protocol: ${err.message}`, {
                position: "top-right",
                autoClose: 3000,
            });
            setCloning(false);
        });
    };

    

    const fetchProtocols = (token, isRefresh = false) => {
        if (isRefresh) {
            setRefreshing(true);
        } else {
            setLoading(true);
        }
        setError(null);

        const tokenToUse = token || authToken;
        if (!tokenToUse) {
            setError('Authentication token not available');
            if (isRefresh) {
                setRefreshing(false);
            } else {
                setLoading(false);
            }
            return;
        }

        fetch('https://s2.genetica.ai:3001/cortex/graphiti/$getObjects', {
            method: 'POST',
            headers: {
                'authorization': `Bearer ${tokenToUse}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify([
                {
                    "published": true,
                    "metadata.categories": "prelim"
                },
                [
                    "name",
                    "description",
                    "metadata.modified",
                    "metadata.categories",
                    "metadata.identifiers",
                    
                    "active"
                ],
                [
                    "metadata.modified"
                ]
            ])
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            response.json().then(data => {
                setProtocols(data);
                if (isRefresh) {
                    setRefreshing(false);
                } else {
                    setLoading(false);
                }
            });
        })
        .catch(err => {
            console.error('Error fetching protocols:', err);
            setError(err.message);
            if (isRefresh) {
                setRefreshing(false);
            } else {
                setLoading(false);
            }
        });
    };

    if (loading) {
        return <div className="loading">Loading preliminary protocols...</div>;
    }

    if (error) {
        return <div className="error">Error: {error}</div>;
    }

    return (
        <div className="preliminary-protocols">
            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                style={{ zIndex: 99999 }}
            />

            {/* Import Protocol Modal */}
            {showModal && (
                <div 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 10000
                    }}
                    onClick={handleModalClose}
                >
                    <div 
                        style={{
                            backgroundColor: 'white',
                            padding: '30px',
                            borderRadius: '8px',
                            minWidth: '500px',
                            maxWidth: '600px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3 style={{ marginBottom: '20px', color: '#333', fontSize: '22px', fontWeight: '600' }}>
                            Import Protocol to Your Library
                        </h3>
                        
                        <p style={{ marginBottom: '25px', color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
                            You're about to import the following protocol into your library:
                        </p>

                        <div style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '600', fontSize: '14px' }}>
                                Protocol Name
                            </label>
                            <input
                                type="text"
                                value={newName}
                                onChange={(e) => setNewName(e.target.value)}
                                placeholder="Enter protocol name"
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box'
                                }}
                                autoFocus
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        cloneProtocol();
                                    }
                                }}
                            />
                        </div>

                        <div style={{ marginBottom: '25px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '600', fontSize: '14px' }}>
                                Description
                            </label>
                            <textarea
                                value={newDescription}
                                onChange={(e) => setNewDescription(e.target.value)}
                                placeholder="Enter protocol description"
                                rows="4"
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box',
                                    resize: 'vertical',
                                    fontFamily: 'inherit'
                                }}
                            />
                        </div>

                        <p style={{ 
                            marginBottom: '25px', 
                            color: '#555', 
                            fontSize: '13px', 
                            lineHeight: '1.6',
                            padding: '12px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '4px',
                            borderLeft: '3px solid #007bff'
                        }}>
                            Once imported, this protocol will be available in your library and ready for further configuration and processing.
                        </p>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button
                                onClick={handleModalClose}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#f0f0f0',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    transition: 'background-color 0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#e0e0e0'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={cloneProtocol}
                                disabled={cloning}
                                style={{
                                    padding: '10px 24px',
                                    backgroundColor: cloning ? '#6c757d' : '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: cloning ? 'not-allowed' : 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    transition: 'background-color 0.2s',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    opacity: cloning ? 0.7 : 1
                                }}
                                onMouseOver={(e) => !cloning && (e.target.style.backgroundColor = '#0056b3')}
                                onMouseOut={(e) => !cloning && (e.target.style.backgroundColor = '#007bff')}
                            >
                                {cloning && (
                                    <div 
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                            border: '2px solid #ffffff',
                                            borderTop: '2px solid transparent',
                                            borderRadius: '50%',
                                            animation: 'spin 0.8s linear infinite'
                                        }}
                                    />
                                )}
                                {cloning ? 'Importing...' : 'Continue & Import'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {refreshing ? (
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    padding: '60px 20px',
                    flexDirection: 'column',
                    gap: '15px'
                }}>
                    <div 
                        style={{
                            width: '40px',
                            height: '40px',
                            border: '4px solid #f3f3f3',
                            borderTop: '4px solid #007bff',
                            borderRadius: '50%',
                            animation: 'spin 0.8s linear infinite'
                        }}
                    />
                    <p style={{ color: '#666', fontSize: '16px', margin: 0 }}>Updating protocols...</p>
                </div>
            ) : protocols.length === 0 ? (
                <p>No protocols found.</p>
            ) : (
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th style={{ width: '30%' }}>Release Date</th>
                                <th>Protocol Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {protocols.map((protocol, index) => (
                                <tr 
                                    key={protocol._id || index} 
                                    // onClick={() => cloneProtocol(protocol)}
                                    title={` ${protocol.description || 'No description available'}`}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td>
                                        {protocol.metadata?.modified
                                            ? new Date(protocol.metadata.modified).toISOString().split('T')[0]
                                            : 'N/A'}
                                    </td>
                                    <td className="d-flex justify-content-between align-items-center">
                                        <span>{protocol.name}</span>
                                        <img
                                            src="/cloud_sync.svg"
                                            alt="sync"
                                            title="Clone Protocol"
                                            className="protocol-icon"
                                            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                                            onClick={(e) => handleCloneClick(e, protocol)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default PreliminaryProtocols;